<div class="ro-card-accordion">
  <p-accordion [multiple]="true">
    <p-accordionTab [selected]="index == '0'">
      <p-header>
        <div class="font-14 flex-between-center">
          <span class="hover-underline pointer font-14 font-700" (click)="openRO(data)">
            RO-{{data.code}}
          </span>

          <div class="pr-2">
            <span class="font-12 font-600">
              {{data?.totalAmount | currency: usd}}
            </span>
          </div>
        </div>
      </p-header>

      <!-- card body -->
      <div class="flex-column p-2">
        

        <div class="border-bottom-lightest flex-start-center gap-2 ui-g-12 pl-0 pr-0">
          <i class="fas fa-truck font-gray-45"></i>
          <span class="font-12 font-400"> Invoiced on  {{data?.invoiceDate}}</span>
        </div>

        <div class="sublet-info-body flex-column">
          <div class="flex-row ui-g-12 pl-0 pr-0" [ngClass]="{'border-bottom-lightest': !lastRow}" *ngFor="let item of data?.items; let lastRow = last;">
            <div class="flex-start-center ui-g-6 pl-0 capitalize">
              <span class="text-truncate font-12 font-400">{{item?.title}}</span>
            </div>
            <div class="flex-end-center ui-g-3 capitalize">
              <span class="font-12 font-400">{{item?.paidStatus}}</span>
            </div>
            <div class="flex-end-center ui-g-3 pr-0">
              <span class="font-12 font-400">{{((item?.subTotal + item?.taxedAmount) || 0) | currency: usd}}</span>
            </div>
          </div>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>

</div>